import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { View } from "react-native";
import GestureHandlerRootViewContext from "../GestureHandlerRootViewContext";
export default function GestureHandlerRootView(props) {
    return /*#__PURE__*/ _jsx(GestureHandlerRootViewContext.Provider, {
        value: true,
        children: /*#__PURE__*/ _jsx(View, _object_spread({}, props))
    });
}
